<template>
    <div>
        <div class="field">
            <p class="control has-icons-left">
                <span class="select">
                   <select v-model="invoiceDetailsId">
                      <option :value="null" disabled>Select Invoice Details</option>
                      <option v-for="detail in invoiceDetails" :value="detail.id">{{ detail.name }}, {{ detail.city }}</option>
                   </select>
                </span>
                <span class="icon is-small is-left">
                   <i class="fas fa-globe"></i>
                </span>
            </p>
        </div>
        <div class="field">
            <p class="control has-icons-left">
                <span class="select">
                   <select v-model="shippingType">
                      <option :value="null" disabled>Select Shipping Type</option>
                      <option :value="1">RoRo</option>
                      <option :value="2">Container</option>
                   </select>
                </span>
                <span class="icon is-small is-left">
                   <i class="fas fa-globe"></i>
                </span>
            </p>
        </div>
    </div>
</template>

<script>
    import apiInvoiceContactDetails from '../../../../api/apiInvoiceContactDetails'
    export default {
        props:['car'],
        data() {
            return {
                invoiceDetails: []
            }
        },
        computed: {
           invoiceDetailsId: {
               get() {
                    return this.$store.getters.getProformaInvoiceQuery.invoice_details_id
               },
               set(value) {
                    this.$store.dispatch('changeProformaInvoiceQueryFieldValue', {field: 'invoice_details_id', value: value })
               }
           },
           shippingType: {
               get() {
                   return this.$store.getters.getProformaInvoiceQuery.shipping_type
               },
               set(value) {
                   this.$store.dispatch('changeProformaInvoiceQueryFieldValue', {field: 'shipping_type', value: value })
               }
           }
        },
        mounted() {
            this.$store.dispatch('changeProformaInvoiceQueryFieldValue', {field: 'car_id', value: this.car.id })
            apiInvoiceContactDetails
                .invoiceContactDetailsListRequest(this.car.user_id)
                .then((response) => {
                    this.invoiceDetails = response.data
                })
                .catch((error) => console.log(error))
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceSelectTypeAndDetails.vue